import { render } from "./NewVendorMaster.vue?vue&type=template&id=4d2835a8"
import script from "./NewVendorMaster.vue?vue&type=script&lang=js"
export * from "./NewVendorMaster.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__